import { PersonalisationHeading } from "./PersonalisationHeading";

interface PersonalisationAIGlossyCardProps {
  className?: string;
  name: string;
  platformName: string;
}

export const PersonalisationAIGlossyCard = ({
  className,
  name,
  platformName,
}: PersonalisationAIGlossyCardProps) => {
  return (
    <div
      className={`
        relative flex w-full max-w-[312px] rounded-2xl
        bg-white/10 px-8 py-6 text-center 
        shadow-subtle backdrop-blur-md backdrop-filter transition-all duration-200
        hover:bg-white/15 ${className}
      `}
      style={{
        border: "1px solid rgb(249, 240, 232)",
        background:
          "linear-gradient(to bottom, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.8))",
      }}
    >
      <div className="flex flex-col gap-6">
        <PersonalisationHeading customSize="25px">
          Nice to meet you, {name}.
        </PersonalisationHeading>

        <p className="text-center text-sm font-normal leading-[18px] text-black">
          I&apos;m your personal advisor, trained on {platformName}&apos;s
          treatments to help you choose what&apos;s right for your goals.
          <br /> <br /> This will take less than 1 minute.
        </p>
      </div>
    </div>
  );
};
